export const initialState = {
  genericFilterParam: {
    paramId: null,
    paramCode: '',
    paramName: '',
    paramTypeId: null,
    inactive: false,
    genericFilterParamXContexts: [],
    genericFilterParamXContextsIds: [],
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    default:
      return state;
  }
}

function onHeaderSaved(state, action) {
  const { paramId } = action;
  return {
    ...state,
    genericFilterParam: {
      ...state.genericFilterParam,
      paramId: paramId,
      changed: false
    }
  };
}

function onInitState(state, action) {
  const { genericFilterParam, genericFilterParamXContexts } = action;
  return {
    ...state,
    genericFilterParam: {
      ...genericFilterParam,
      genericFilterParamXContexts,
      genericFilterParamXContextsIds: genericFilterParamXContexts.map(x => x.contextId),
      changed: false
    }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  let payload = {
    ...state,
    genericFilterParam: {
      ...state.genericFilterParam,
      [propertyName]: value,
      changed: true
    }
  };

  if (propertyName === 'filterXContextsIds') {
    payload = {
      ...state,
      genericFilterParam: {
        ...state.genericFilterParam,
        genericFilterParamXContextsIds: value,
        genericFilterParamXContexts: value?.map(x => {
          return {
            id: state.genericFilterParam.genericFilterParamXContexts.find(y => y.contextId === x.id)?.id,
            paramId: state.genericFilterParam.paramId,
            contextId: x.id,
            contextName: x.name
          };
        }),
        changed: true
      }
    };
  }

  return {
    ...state,
    ...payload
  };
}
